// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, getJobListForProfessional } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitJobListProfessionalApi = createAsyncThunk(
  "hitJobListProfessionalApi",
  async (payload) => {
    try {
      const config = {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          Authorization: `${localStorage.getItem("professionalToken")}`,
        },
        params: payload,
      };
      const url = ApiBaseUrl + getJobListForProfessional;
      const response = await axios.get(url, config);
      return response.data;
    } catch (error) {
      toast.error(error.response.data.message);
      throw error.response.data;
    }
  }
);

const JobListProfessionalSlice = createSlice({
  name: "jobListProfessionalReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitJobListProData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitJobListProfessionalApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitJobListProfessionalApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitJobListProfessionalApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitJobListProData } = JobListProfessionalSlice.actions;
export default JobListProfessionalSlice.reducer;
